import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import styles from './styles.css';
import { modalCloseHandler, modalCloseNextModalHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';

const modalInstructions =
  'If you continue, your account will be set up without designated beneficiaries. You can make changes to your beneficiaries at any time.';

const modalTitle = 'Are you sure you want to skip this step?';

const SkipBeneficiariesModal = () => {
  const { next, closeNextModal } = useContext(FlowContext);

  return (
    <>
      <MFBeaconModal open removeCloseButton role="dialog">
        <span className="modal-close-icon">
          <MFBeaconIconButton
            role="button"
            id="skipBeneModalCloseIcon"
            variant="tertiary"
            onClick={() => modalCloseNextModalHandler(closeNextModal)}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
        <div className="beacon-modal__title">{modalTitle}</div>
        <div className="beacon-modal__description">{modalInstructions}</div>
        <div slot="action-zone" className="skip-bene-btn-container">
          <MFBeaconButton
            role="button"
            noButtonMargin
            variant="tertiary"
            id="skipBeneModalClose"
            type="button"
            onClick={() => modalCloseNextModalHandler(closeNextModal)}
            label="Cancel"
          />
          <MFBeaconButton
            noButtonMargin
            role="button"
            variant="primary"
            id="skipBeneModalContinue"
            type="button"
            onClick={() => {
              modalCloseHandler();
              next('skip')();
            }}
            label="Continue"
          />
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default SkipBeneficiariesModal;
